module.exports = __webpack_public_path__ + "img/20240906_huangyong.b8b20214.jpg";